import { getCurrentPageUrl, getLangCode, getTimeStamp, pushToDataLayer } from './utils/helpers';
import { GTMLists, GtmDimensions, GtmEventNames, GTMCategories, GTMActions } from 'google-tag-manager';

export const fireWorldWideImpressionEvent = () => {
  pushToDataLayer({
    [GtmDimensions.event]: GtmEventNames.modalImpression,
    [GtmDimensions.timestamp]: getTimeStamp(),
    [GtmDimensions.location]: GTMLists.flightGrid,
    [GtmDimensions.name]: GTMCategories.addMoreFlightsModal,
    pageLanguage: getLangCode(),
    pageUrl: getCurrentPageUrl()
  });
};

export const fireGoToWorldWideEvent = () => {
  pushToDataLayer({
    [GtmDimensions.event]: GtmEventNames.modalInteraction,
    [GtmDimensions.action]: GTMActions.bookOnWorldWide,
    [GtmDimensions.timestamp]: getTimeStamp(),
    [GtmDimensions.location]: GTMLists.flightGrid,
    [GtmDimensions.name]: GTMCategories.addMoreFlightsModal,
    pageLanguage: getLangCode(),
    pageUrl: getCurrentPageUrl()
  });
};

export const fireStayOnEasyjetWorldWideEvent = () => {
  pushToDataLayer({
    [GtmDimensions.event]: GtmEventNames.modalInteraction,
    [GtmDimensions.action]: GTMActions.continueWithCurrentBooking,
    [GtmDimensions.timestamp]: getTimeStamp(),
    [GtmDimensions.location]: GTMLists.flightGrid,
    [GtmDimensions.name]: GTMCategories.addMoreFlightsModal,
    pageLanguage: getLangCode(),
    pageUrl: getCurrentPageUrl()
  });
};
